import BaseWalletService from './base-wallet-service';
import WalletService from './wallet-service';

import { extractAccount } from '../../helpers/tools';

// Read lazily: the wallet (Casa Tookan) injects window.webXCP into the page,
// and on some WebViews that lands after this module is evaluated.
const getWebXcp = () => window.webXCP;

// Long enough for the user to answer the wallet's connect prompt.
const GET_ACCOUNTS_TIMEOUT_MS = 120000;

export default class WebXcpService extends BaseWalletService implements WalletService {
  private pendingAccounts?: Promise<string>;

  // webXCP.getAccounts(basePath, cb) answers through a node-style callback,
  // either synchronously (legacy Casa Tookan) or once the user approved the
  // connection (new Casa Tookan). Wait for the callback instead of a fixed
  // delay; concurrent callers share the same request so only one prompt shows.
  getAccounts = (): Promise<string> => {
    if (this.pendingAccounts) return this.pendingAccounts;

    const webXCP = getWebXcp();
    if (!webXCP) return Promise.resolve('');

    const request = new Promise<string>((resolve) => {
      let settled = false;
      let timer: ReturnType<typeof setTimeout> | undefined;
      const finish = (address: string) => {
        if (settled) return;
        settled = true;
        if (timer) clearTimeout(timer);
        resolve(address || '');
      };
      timer = setTimeout(() => finish(''), GET_ACCOUNTS_TIMEOUT_MS);

      try {
        webXCP.getAccounts(null, (err: unknown, bitcoinAddress: string | string[]) => {
          if (err) {
            this.logError(err);
            finish('');
            return;
          }
          finish(extractAccount(bitcoinAddress));
        });
      } catch (err) {
        this.logError(err);
        finish('');
      }
    });

    // cleared after the fact: a synchronous callback settles before this line
    this.pendingAccounts = request;
    request.then(() => {
      if (this.pendingAccounts === request) this.pendingAccounts = undefined;
    });
    return request;
  };

  init = async (
    newChainHandler?: (chainId: number) => void,
    newNetworkHandler?: (networkId: number) => void,
    newAccountHandler?: (newAccounts: string | string[]) => void
  ) => {
    super.init(undefined, undefined, newAccountHandler);
  };

  isWalletInstalled = () => Boolean(getWebXcp());

  connect = async () => {
    const account = await this.getAccounts();
    this.handleNewAccounts(account);
  };

  getDownloadWalletPath = (): string => {
    return '';
  };

  getName = (): string => {
    return 'Counterparty';
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  personalSign = async (message: string, password?: string): Promise<string> => {
    throw new Error('Method not implemented.');
  };
}
